'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filterSumPaeth;

var _paethPredictor = require('../../paeth-predictor');

var _paethPredictor2 = _interopRequireDefault(_paethPredictor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterSumPaeth(pxData, pxPos, byteWidth, bpp) {
  var sum = 0;
  for (var x = 0; x < byteWidth; x++) {
    var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
    var up = pxPos > 0 ? pxData[pxPos + x - byteWidth] : 0;
    var upleft = pxPos > 0 && x >= bpp ? pxData[pxPos + x - (byteWidth + bpp)] : 0;
    var val = pxData[pxPos + x] - (0, _paethPredictor2.default)(left, up, upleft);

    sum += Math.abs(val);
  }

  return sum;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/filter/pack/filterSumPaeth.js
// module id = 1086
// module chunks = 0